module.exports = __webpack_public_path__ + "static/media/trait-icons-motivation.d5fda0b7.svg";